<template>
	<!-- 会员支付页面 -->
	<div class="pay">
		<publicHeader :pageTitle="pageTitle" v-if="!noHeader" :urlhandle="urlhandle"></publicHeader>
		<div class="zhanwei" v-if="!noHeader"></div>
		<!-- 个人信息/未登录 -->
		<div class="contents userInfo">
			<div class="infoBox" @click="gotoLogin">
				<div class="userHeadImg">
					<img :src="vipUserInfo.userHeadImg" alt="" v-if="vipUserInfo.userHeadImg" />
				</div>
				<div class="moreInfo">
					<div class="info1">
						<!-- 昵称 -->
						<div class="userName">{{ vipUserInfo.userName }}</div>
						<!-- 徽章 -->
						<div class="badge" v-if="vipUserInfo.userVipLogo">
							<img :src="vipUserInfo.userVipLogo" alt="" />
						</div>
					</div>
					<!-- 各种状态 -->
					<div class="info2">
						<!-- 到期时间(已购买) -->
						<!-- <div class="status" v-if="!isLogin">购买会员享受更多服务</div> -->
						<!-- 到期时间(已购买) -->
						<!-- <div class="status" v-if="userInfo.status===0">到期时间：{{userInfo.expire}}</div> -->
						<!-- 已过期多少天（已过期） -->
						<!-- <div class="status" v-if="userInfo.status===1">已过期{{userInfo.overdueTime}}天</div> -->
						<!-- 文案（未购买） -->
						<!-- <div class="status oColor" v-if="userInfo.status===2">您还不是{{userInfo.vipType}}哦~</div> -->
						<div class="status">{{ vipUserInfo.vipDesc }}</div>
					</div>
					<!-- 成长值 -->
					<div class="info3" @click="gotoGrow">
						<div class="grow" v-if="vipUserInfo.vipDetail && vipUserInfo.vipDetail.code">
							<div class="word">成长值：</div>
							<div class="progress">
								<div class="smallPro" :style="{
                    width:
                      (vipUserInfo.vipDetail.exp /
                        Number(vipUserInfo.vipDetail.nextLevelExp)) *
                        100 +
                      '%'
                  }"></div>
							</div>
							<div class="num">
								<span class="growth">{{ vipUserInfo.vipDetail.exp }}</span><span
									class="nextGrowth">/{{ vipUserInfo.vipDetail.nextLevelExp }}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 自动续费管理按钮(已登录才显示) -->
				<div class="autoRenew" v-if="isLogin && hasAuto" @click="gotoRenew">
					自动续费管理
				</div>
			</div>
		</div>
		<!-- 会员挡位 -->
		<div class="contents norp">
			<div class="vipGear">
				<div class="gearItem" v-for="(item, index) in vipCardPrice" :key="index" :class="{
            lastItem: index === vipCardPrice.length - 1,
            activeItem: index === checkedIndex,
            firstItem: index === 0
          }" @click="changeIndex(index)">
					<!-- 会员时长 -->
					<div v-if="item.auto">
						<!-- 连续包月 -->
						<div class="duration">连续包月</div>
						<!-- 有效期 -->
						<div class="term">有效期30天</div>
						<!-- 现价 -->
						<div class="renewPrice">
							<span class="rmb">￥</span>{{ item.price }}
						</div>
						<!-- 原价 -->
						<div class="wordInfo">连续包月可随时取消</div>
						<!-- 描述图标 -->
						<div class="autoImg" v-if="item.autoImg">
							<img :src="item.autoImg" alt="" />
						</div>
						<div class="desc blackDesc" v-else>包月更划算</div>
					</div>
					<div v-else>
						<!-- 非连续包月 -->
						<div class="duration" v-if="item.showTimeType === '0'">
							{{ item.showTime }}个月
						</div>
						<div class="duration" v-if="item.showTimeType === '1'">
							{{ item.showTime / 24 }}日
						</div>
						<!-- 有效期 -->
						<div class="term" v-if="item.showTimeType === '0'">
							有效期{{ item.showTime * 30 }}天
						</div>
						<div class="term" v-if="item.showTimeType === '1'">
							有效期{{ item.showTime }}小时
						</div>
						<!-- 现价 -->
						<div class="renewPrice">
							<span class="rmb">￥</span>{{ item.hasDiscountIos ? item.iosPrice : item.iosPriceInitial }}
						</div>
						<!-- 原价 -->
						<div class="oldPrice" v-if="item.hasDiscountIos">
							<del>￥{{ item.iosPriceInitial }}</del>
						</div>
						<!-- 描述图标 -->
						<div class="desc redDesc" v-if="item.payDesc != ''">
							{{ item.payDesc }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 连续包月提示 -->
		<div class="contents autoPayTips" v-if="vipCardPrice[checkedIndex] && vipCardPrice[checkedIndex].auto">
			到期自动扣费，会员延长30天，可取消（取消后不再自动扣费）
		</div>
		<!-- 会员权益 -->
		<div class="contents">
			<div class="vipRights">
				<div class="titleSty">
					<div class="title">会员权益</div>
				</div>
				<div class="rightsBox">
					<div class="rightsItem" v-for="(item, index) in vipRights" :key="index">
						<div class="itemIcon">
							<img :src="
                  `https://images.zhibo.tv/2020/1109/icon_rights${index +
                    1}@2x.png`
                " alt="" />
						</div>
						<div class="itemName">
							{{ item.name }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 专享赛事 -->
		<div class="contents" @click="gotoMatch" v-if="hasMatch === '1'">
			<div class="match">查看{{ payName }}专享赛事</div>
		</div>
		<!-- 自动续费说明（ios） -->
		<div class="contents">
			<div class="renewDesc">
				<div class="renewTitle">
					中国体育自动续费服务说明
				</div>
				<div class="descInfo">
					1、付款：用户确认购买并付款后计入iTunes账户；<br />
					2、取消续订：如需取消续订，请在当前订阅周期到期前24小时以内，手动在iTunes/Apple
					ID
					设置管理中关闭自动续费功能，到期前24小时内取消，将会收取订阅费用；<br />
					3、续费：苹果iTunes账户会在到期前24小时内扣费，扣费成功后订阅周期顺延一个订阅周期。<br />
				</div>
			</div>
		</div>
		<!-- 其他服务 -->
		<div class="contents serves">
			<div class="serveItem" @click="gotoPrivacy">
				隐私条款
			</div>
			<div class="serveItem" @click="gotoAgreement">
				自动续费服务协议
			</div>
			<div class="serveItem" @click="gotoVipPrivilege">
				会员服务协议
			</div>
			<div class="serveItem" @click="callKefu">
				联系客服
			</div>
			<div class="serveItem" @click="gotoVipRefund" v-if="refundSwitch == 1 && token && isShowRefund">
				会员退费
			</div>
		</div>
		<!-- 解释权(ios) -->
		<div class="contents rights">
			活动由新传在线（北京）信息技术有限公司提供，<br />
			与苹果公司apple.inc无关
		</div>
		<!-- 底部固定 -->
		<div class="payInfo">
			<div class="agreement">
				<div @click="agreement = !agreement" class="img-box">
					<img v-if="agreement" class="checked" src="https://static-vip.sports.cctv.com/cctv-vip/pc/loginfootIcon/selected_icon.png" />
					<img v-else class="checked" src="https://padi-img.zhibo.tv/web/circle/mine_noselect.png" />
				</div>
				<div class="agreement_text">我已阅读并同意<span @click="gotoVipPrivilege">《会员服务协议》</span></div>
			</div>
			<div class="payBox">
				<div class="total">
					<div class="priceInfo">
						<div class="word">总计:</div>
						<div class="price"><span class="rmb">￥</span>{{ payPrice }}</div>
					</div>
					<!-- <div class="agreement">
						<div class="agree1">支付即同意</div>
						<div class="agree2" @click="gotoVipPrivilege">会员服务协议>></div>
					</div> -->
				</div>
				<div class="payBtn" @click="payDialogShow">确认支付</div>
			</div>
		</div>
		<!-- 提示弹框 -->
		<publicDialog :info="info" :title="title" :btn1="btn1" :btn2="btn2" @changeShow="showDialog"
			:dialogIsShow="dialogIsShow" :height="height" v-show="dialogIsShow" :paySuccess="paySuccess"></publicDialog>
		<publicToast :info='info' v-show="info"></publicToast>
	</div>
</template>

<script>
	import publicDialog from '../components/PublicDialog'
	import publicHeader from '../components/PublicHeader'
	import publicToast from '../components/publicToast'
	export default {
		name: 'vipPay',
		components: {
			publicDialog,
			publicHeader,
			publicToast
		},
		data() {
			return {
				id: '',
				// 选中的挡位
				checkedIndex: 0,
				//是否登录
				isLogin: false,
				// 是否ios
				isIOS: false,
				// 支付信息
				payName: '中国体育超级会员',
				// payPrice: '16.00',
				payType: [5, 6, 2],
				isShowDialog: false,
				// 个人信息
				userInfo: {
					userHeadImg: '',
					userName: '立即登录',
					status: -1,
					expire: '2020年7月13日',
					overdueTime: '10',
					vipType: '中国体育超级会员',
					growth: 1500,
					nextGrowth: 3000,
					badge: 'https://images.zhibo.tv/pc/rich/rich6.png'
				},
				// 接口返回个人的会员信息
				vipUserInfo: {},
				// 接口返回的会员挡位
				vipCardPrice: [],
				// 会员挡位
				vipDetail: {},
				//会员权益
				vipRights: [{
						name: '赛事随心看'
					},
					{
						name: '彩色弹幕'
					},
					{
						name: '生日祝福'
					},
					{
						name: '观赛券'
					},
					{
						name: '商品折扣'
					},
					{
						name: '全服喇叭'
					},
					{
						name: '免广告'
					},
					{
						name: '会员蓝光'
					},
					{
						name: '进场道具'
					}
				],
				// ios支付所需
				productId: '',
				// vipid
				vipId: '',
				// 弹窗需要
				// dialog的提示内容
				dialogIsShow: false,
				info: '',
				title: '提示',
				btn1: '',
				btn2: '我知道了',
				height: '',
				paySuccess: false,
				// 该会员有自动续费
				hasAuto: false,
				// 客服信息
				serviceInfo: '',
				// 是否有专享赛事
				hasMatch: '',
				// 专享赛事地址
				matchUrl: '',
				token: '',
				pageTitle: '',
				// 是否需要公共头
				noHeader: false,
				urlhandle: '',
				canbuy: true,
				// 是否首次退费
				isFirstRefund: '',
				isVip: '',
				isShowRefund: false,
				refundSwitch: '',
				notSaleVip: [], //不可售卖会员

				agreement: false,
			}
		},
		created() {
			this.noHeader = this.$route.query.noHeader
			console.log(this.noHeader)
			this.getToken()
			this.id = this.$route.query.id
			this.type = this.$route.query.type
			console.log('是否是IOS', this.$CONFIG.isIOS)
			this.isIOS = this.$CONFIG.isIOS
			console.log(this.isIOS)
			if (!this.token) {
				this.isLogin = false
				this.vipUserInfo = {
					userHeadImg: '',
					userName: '立即登录',
					vipDesc: '购买会员享受更多服务'
				}
			} else {
				this.isLogin = true
			}
			this.payName = this.userInfo.vipType
			if(this.id==52){
				this.vipRights.splice(0,1,{name:'赛事回放'})
			}
		},
		mounted() {
			// alert(this.userInfo.vipType)
			document.title = this.userInfo.vipType
			// alert(document.title)
			this.getVipInfo()
			// 获取不可销售会员id
			this.getNotSaleVip()
			window.VIP_CENTER = {
				paySucc: () => {
					this.info = '您已成功购买会员'
					this.paySuccess = true
					this.showDialog(true)
				}
			}
		},
		computed: {
			payPrice: function() {
				let result = ''
				if (this.vipCardPrice.length < 1) {
					return
				}
				if (this.vipCardPrice[this.checkedIndex].auto) {
					result = this.vipCardPrice[this.checkedIndex].price
				} else {
					if (
						this.vipCardPrice.length > 0 &&
						this.vipCardPrice[this.checkedIndex].hasDiscountIos
					) {
						result = this.vipCardPrice[this.checkedIndex].iosPrice
					} else {
						result = this.vipCardPrice[this.checkedIndex].iosPriceInitial
					}
				}

				return result
			}
			// processWidth:function(){
			//   return userInfo.vipDetail.nextLevelExp
			// }
		},
		beforeRouteEnter(to, from, next) {
			console.log(to.name === 'vipiosPay' && from.name === 'vipcoupon')
			if (to.name === 'vipiosPay' && from.name === 'vipcoupon') {
				next((vm) => {
					console.log(vm)
					vm.urlhandle = 'back'
				})
			}
			next()
		},
		methods: {
			// 跳转会员退费
			gotoVipRefund() {
				console.log('退费id', this.isFirstRefund)
				if (this.isFirstRefund == 0) {
					// 首次退费跳转会员退费
					this.$router.push(`/viprefund?token=${this.token}&vipId=${this.id}`)
				} else {
					// 跳转最近的退费详情
					this.$router.push(`/viprefundinfo?token=${this.token}&vipId=${this.id}&id=${this.isFirstRefund}`)
				}
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				console.log(this.token)
			},
			// 跳转两端新容器
			jumpweb(url) {
				console.log(url)
				var androidParam = '{"url":"' + url + '"}'
				var iosParam = {
					url: url
				}
				try {
					window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
				} catch (e) {
					console.log('ios打开新页面失败')
				}

				try {
					window.LiveAppJS.jumpWeb(androidParam)
				} catch (e) {
					console.log('安卓打开新页面失败')
				}
			},
			// 获取会员的支付信息
			getVipInfo() {
				let params = {
					type: this.type,
					token: this.token,
					id: this.id,
					statistics: this.$CONFIG.statistics,
					pt: 2
				}
				this.$vipapi.getVipInfo(params).then((res) => {
					if (res.data.data.vipUserInfo.userName.length > 0) {
						this.vipUserInfo = res.data.data.vipUserInfo
					}
					this.hasMatch = res.data.data.vipCardInfo.hasMatch
					this.matchUrl = res.data.data.vipCardInfo.matchUrl
					// 客服信息
					this.serviceInfo = res.data.data.service
					this.vipCardPrice = res.data.data.vipCardPrice
					this.productId = this.vipCardPrice[0].iosProductId
					this.vipId = this.vipCardPrice[0].vipId
					this.payName = res.data.data.vipCardInfo.vipName + '会员'
					document.title = this.payName
					this.pageTitle = this.payName
					this.changeAppTitle(this.pageTitle)
					console.log(this.vipCardPrice)
					this.hasAuto = res.data.data.hasAuto
					// for (let index = 0;index < this.vipCardPrice.length;index++) {
					//   if (this.vipCardPrice[index].auto) {
					//     // 可以展示连续包月
					//     this.hasAuto = true
					//   }
					// }
					// if (this.vipCardPrice[0].auto) {
					//   console.log('是连续包月')
					//   this.hasAuto = true
					// }
					this.isFirstRefund = res.data.data.hasVipRefundRecord
					this.isVip = res.data.data.isVip
					this.refundSwitch = res.data.data.vipCardInfo.refundSwitch
					// 如果是首次退费并且不是会员   就不展示会员退费入口
					if (this.isFirstRefund == 0 && this.isVip == 0) {
						this.isShowRefund = false
					} else {
						this.isShowRefund = true
					}
				})
			},
			// 限制购买
			limitPay() {
				this.timer = setTimeout(() => {
					this.canbuy = true
				}, 2000)
			},
			// 修改选中挡位信息
			changeIndex(index) {
				clearTimeout(this.timer)
				this.canbuy = true
				this.checkedIndex = index
				// 更换ios产品id
				this.productId = this.vipCardPrice[index].iosProductId
				this.vipId = this.vipCardPrice[index].vipId
				// vipid
				console.log(this.productId)
			},
			// 跳转登录
			gotoLogin() {
				if (!this.token) {
					this.phoneLogin()
				}
			},
			// 跳转专享赛事
			gotoMatch() {
				let url = this.matchUrl
				this.jumpweb(url)
			},
			// 跳转会员续费管理
			gotoRenew() {
				if (this.noHeader) {
					this.$router.push(
						`/viprenew?id=${this.id}&token=${this.token}&noHeader=0`
					)
				} else {
					this.$router.push(`/viprenew?id=${this.id}&token=${this.token}`)
				}
			},
			// 跳转会员成长体系
			gotoGrow() {
				if (this.token) {
					if (this.noHeader) {
						this.$router.push(
							`/vipgrow?id=${this.id}&token=${this.token}&noHeader=0`
						)
					} else {
						this.$router.push(`/vipgrow?id=${this.id}&token=${this.token}`)
					}
				}
			},
			// 跳转隐私条款
			gotoPrivacy() {
				// window.open('http://static.zhibo.tv/agreement/privacy_agreement.html')
				let url = 'http://static.zhibo.tv/agreement/privacy_agreement.html'
				var androidParam = '{"url":"' + url + '"}'
				var iosParam = {
					url: url
				}
				try {
					window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
				} catch (e) {
					console.log('ios打开新页面失败')
				}

				try {
					window.LiveAppJS.jumpWeb(androidParam)
				} catch (e) {
					console.log('安卓打开新页面失败')
				}
			},
			// 跳转会员服务协议
			gotoVipPrivilege() {
				// window.location.href = "http://vip.zhibo.tv/vip/privilege-explain"
				let url = 'http://vip.zhibo.tv/vip/privilege-explain'
				var androidParam = '{"url":"' + url + '"}'
				var iosParam = {
					url: url
				}
				try {
					window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
				} catch (e) {
					console.log('ios打开新页面失败')
				}

				try {
					window.LiveAppJS.jumpWeb(androidParam)
				} catch (e) {
					console.log('安卓打开新页面失败')
				}
			},
			// 跳转自动续费服务协议
			gotoAgreement() {
				// window.open('http://vip.zhibo.tv/vip/auto-pay-declare')
				let url = 'http://vip.zhibo.tv/vip/auto-pay-declare'
				var androidParam = '{"url":"' + url + '"}'
				var iosParam = {
					url: url
				}
				try {
					window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
				} catch (e) {
					console.log('ios打开新页面失败')
				}

				try {
					window.LiveAppJS.jumpWeb(androidParam)
				} catch (e) {
					console.log('安卓打开新页面失败')
				}
			},
			// 隐藏toast提示
			hideInfo() {
				this.info = ''
			},
			getNotSaleVip(){
				this.$vipapi.getNotSaleVip().then(res => {
					if(res.data.control.status === 200){
						this.notSaleVip = res.data.data
					}
				})
			},
			payDialogShow() {
				if (!this.agreement) {
					this.info = '请阅读并同意用户协议'
					setTimeout(this.hideInfo, 1500)
					return false
				}
				if (this.notSaleVip.includes(this.id)) {
					this.info = '会员调整中，暂时无法购买'
					setTimeout(this.hideInfo, 1500)
				} else {
					if (this.token) {
						console.log('已经登录')
						// this.gotoIOSPay()
						if (this.vipCardPrice[this.checkedIndex].auto === 1) {
							// 先判断一下该用户是否可以购买连续包月
							this.IOSCanBuy()
						} else {
							// 直接调用两端方法购买会员
							this.gotoIOSPay()
						}
					} else {
						this.phoneLogin()
					}
				}
			},
			// 判断IOS用户是否可购买
			async IOSCanBuy() {
				let params =
					`token=${this.token}&productId=${this.productId}&bagType=2&statistics=${this.$CONFIG.statistics}`
				let res = await this.$vipapi.IOSCanBuy(params)
				console.log(res)
				if (res.data.status === '200') {
					// 可以购买
					this.gotoIOSPay()
				} else if (res.data.status === 802) {
					if (res.data.addition.nextFeeTime && res.data.addition.fee) {
						// 已经购买过了
						this.title = '您目前已订阅此项目'
						this.info = `您订阅的“连续包月会员”将于${res.data.addition.nextFeeTime}续期，价格为￥${res.data.addition.fee}元。`;
						(this.btn2 = '我知道了'), this.showDialog(true)
					} else {
						this.title = '提示'
						this.info =
							'您已开通连续包月,如有疑问,请联系客服,客服电话: 400-801-5553'
						this.btn1 = ''
						this.btn2 = '我知道了'
						this.showDialog(true)
					}
				}
			},
			// 苹果支付
			gotoIOSPay() {
				if (this.canbuy) {
					this.canbuy = false
					this.limitPay()
					console.log(this.productId, this.vipId)
					try {
						window.webkit.messageHandlers.paymentWithProduct.postMessage({
							productId: this.productId,
							vipId: this.vipId
						})
						return
					} catch (error) {
						console.log('error', {
							productId: this.productId,
							vipId: this.vipId
						})
					}
				} else {
					this.info = '操作频繁，请稍后!';
					(this.btn1 = ''), (this.btn2 = '我知道了'), this.showDialog(true)
				}
			},
			// 联系客服
			callKefu() {
				if (!this.token) {
					this.phoneLogin()
				} else {
					let sedata = {
						userId: this.serviceInfo.userId,
						userHeadImg: this.serviceInfo.userHeadImg,
						username: this.serviceInfo.userName
					}
					window.console.log(sedata)
					try {
						window.webkit.messageHandlers.systemService.postMessage(sedata)
					} catch (e) {
						window.console.log('ios拉起联系客服失败')
					}
					try {
						window.LiveAppJS.systemService(
							this.serviceInfo.userId,
							this.serviceInfo.userName,
							this.serviceInfo.userHeadImg,
							this.serviceInfo.telPhone
						)
					} catch (e) {
						window.console.log('Android拉起联系客服失败')
					}
				}
			},
			// 两端的登录方法
			phoneLogin() {
				// 安卓登录
				try {
					window.LiveAppJS.login()
				} catch (e) {
					console.log('error')
				}
				// IOS登录
				try {
					window.webkit.messageHandlers.isnotlogin.postMessage('login')
				} catch (e) {
					console.log('error')
				}
			},
			// 展示提示弹窗
			showDialog(visible) {
				this.dialogIsShow = visible
			},
			// 修改两端标题
			changeAppTitle(newtitle) {
				try {
					window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
				} catch (e) {
					console.log('IOS修改标题', newtitle)
				}
				try {
					window.LiveAppJS.changeTitle(newtitle)
				} catch (e) {
					console.log('安卓修改标题', newtitle)
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	.pay {
		width: 7.5rem;
		min-height: calc(100vh - 1.3rem);
		margin: 0 auto;
		margin-bottom: 1.9rem;
		overflow: scroll;
		-ms-overflow-style: none;
		// overflow: -moz-scrollbars-none;
		// overflow: scroll;
		// -ms-overflow-style: none;
		// -webkit-overflow-scrolling: touch; //让滚动更流畅，其实就是滚动有延缓，不设置只要手指离开就立刻停止，感觉体验商是一种不流畅
		// ::-webkit-scrollbar-track {
		//   background-color: transparent;
		// }

		// ::-webkit-scrollbar {
		//   background-color: transparent;
		// }
		// ::-webkit-scrollbar-thumb {
		//   background-color: rgba(0, 0, 0, 0);
		// }
		// 统一样式
		.contents {
			padding: 0 0.3rem;
		}

		.norp {
			padding-right: 0;
			padding-left: 0;
		}

		// 统一样式
		.titleSty {
			display: flex;
			justify-content: space-between;
			margin-bottom: 0.3rem;

			// 标题
			.title {
				font-size: 0.34rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #222222;
			}

			// 更多
			.more {
				font-size: 0.28rem;
				font-family: PingFangSC-Light, PingFang SC;
				font-weight: 300;
				color: #999999;

				i {
					display: inline-block;
					width: 0.09rem;
					height: 0.16rem;
					background: url('https://images.zhibo.tv/2020/1103/icon_moreRight@2x.png');
					background-size: 100%;
				}
			}
		}

		// 个人信息
		.userInfo {
			width: 100%;
			height: 2.3rem;
			padding: 0;
			background: #222223;
			overflow: hidden;

			.infoBox {
				width: 6.3rem;
				height: 1.4rem;
				padding: 0.3rem;
				margin: 0 auto;
				margin-top: 0.3rem;
				background: linear-gradient(180deg, #47464b 0%, #222223 100%);
				border-radius: 0.08rem 0.08rem 0 0;
				position: relative;
				display: flex;

				// 头像
				.userHeadImg {
					width: 0.9rem;
					height: 0.9rem;
					border-radius: 50%;
					margin-right: 0.2rem;
					background: url('https://images.zhibo.tv/2021/0312/icon_logo.png') no-repeat center center;
					background-size: 100%;
					border: 0.02rem solid #d8bea4;

					img {
						display: block;
						width: 0.9rem;
						height: 0.9rem;
						border-radius: 50%;
					}
				}

				// 其他信息
				.moreInfo {
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.info1 {
						display: flex;
						align-items: center;

						// 昵称
						.userName {
							max-width: 2.6rem;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-size: 0.32rem;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							color: #d8bea4;
						}

						// 徽章
						.badge {
							width: 0.7rem;
							height: 0.3rem;
							margin-left: 0.1rem;

							img {
								display: block;
								widows: 0.7rem;
								height: 0.3rem;
							}
						}
					}

					.info2 {
						display: flex;
						align-items: flex-start;

						.status {
							font-size: 0.26rem;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #d8bea4;
						}

						.oColor {
							color: #999999;
						}
					}

					.info3 {
						height: 0.34rem;

						.grow {
							display: flex;
							justify-content: center;
							align-items: center;

							// 成长值三个字
							.word {
								flex-shrink: 0;
								font-size: 0.26rem;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #999999;
							}

							// 进度条
							.progress {
								width: 2.6rem;
								height: 0.12rem;
								overflow: hidden;
								margin-right: 0.13rem;
								background: #353844;
								border-radius: 0.07rem;

								.smallPro {
									height: 0.12rem;
									border-radius: 0.07rem;
									background: #8d746b;
								}
							}

							// 数字
							.num {
								font-size: 0.26rem;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #d8bea4;

								.growth {}

								.nextGrowth {
									color: #999;
								}
							}
						}
					}
				}

				// 自动续费管理按钮
				.autoRenew {
					width: 1.8rem;
					height: 0.54rem;
					// margin-top: 0.5rem;
					border-radius: 0.3rem;
					border: 0.02rem solid rgba(216, 190, 164, 0.5);
					display: flex;
					justify-content: center;
					align-items: center;
					position: absolute;
					top: 0.25rem;
					right: 0.2rem;

					font-size: 0.24rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #d8bea4;
				}
			}
		}

		// 会员挡位
		.vipGear {
			// display: flex;
			margin-top: 0.33rem;
			overflow: scroll;
			white-space: nowrap;
			height: 2.56rem;
			font-size: 0;

			// background: red;
			&::-webkit-scrollbar {
				display: none;
				/* Chrome Safari */
			}

			.gearItem {
				// -webkit-tap-highlight-color: rgba(0,0,0,0);
				-webkit-tap-highlight-color: transparent;
				display: inline-flex;
				flex-direction: column;
				font-size: 0;
				flex-shrink: 0;
				width: 2.1rem;
				height: 2.4rem;
				box-sizing: border-box;
				margin: 0.08rem 0 0.06rem 0.2rem;
				// margin-right: 0.2rem;
				// margin-top: 0.06rem;
				// margin-bottom: 0.4rem;
				padding: 0.4rem 0 0.1rem 0;
				background: #fef9f2;
				border-radius: 0.07rem;
				border: 0.14vw solid #e8c182;
				position: relative;
				text-align: center;

				// 会员时长
				.duration {
					font-size: 0.3rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 600;
					color: #666;
				}

				// 有效期
				.term {
					font-size: 0.24rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999;
					line-height: 0.33rem;
					margin: 0.1rem 0;
				}

				// 现价
				.renewPrice {
					font-size: 0.6rem;
					font-family: BebasNeue;
					color: #a57359;
					line-height: 1;

					.rmb {
						font-size: 0.3rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #a57359;
					}
				}

				// 原价
				.oldPrice {
					font-size: 0.24rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
				}

				// 连续包月描述
				.wordInfo {
					// transform: scale(0.75);
					font-size: 0.16rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #666666;
				}

				// 描述图标
				.desc {
					position: absolute;
					top: -0.05rem;
					right: -0.01rem;
					padding: 0 0.15rem;
					font-size: 0.2rem;

					background: linear-gradient(135deg,
							#ff6777 0%,
							#fb7d54 47%,
							#ee4f46 100%);
					border-radius: 0 0.12rem 0 0.12rem;

					font-size: 0.24rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #ffffff;
					text-shadow: 0 0.02rem 0.04rem rgba(255, 0, 0, 0.5);
				}

				// 连续包月永远是黑的
				.blackDesc {
					color: #d8bea4;
					background: linear-gradient(308deg, #342b2e 0%, #433e3e 100%);
				}

				// 其他挡位的活动永远是红的
				.redDesc {
					color: #ffffff;
					background: linear-gradient(135deg,
							#ff6777 0%,
							#fb7d54 47%,
							#ee4f46 100%);
				}

				.autoImg {
					position: absolute;
					top: -0.06rem;
					right: -0.02rem;

					img {
						height: 0.32rem;
					}
				}
			}

			.lastItem {
				margin-right: 0.3rem;
			}

			.firstItem {
				margin-left: 0.3rem;
			}

			// 第一个特殊样式
			.activeItem {
				-webkit-tap-highlight-color: transparent;
				background: linear-gradient(120deg,
						#f3e7d8 0%,
						#ead4bc 54%,
						#f6e5c9 100%);
				border: 0.01rem solid #bf8e67;

				.duration {
					color: #613f25;
				}

				.term {
					color: #613f25;
				}

				.renewPrice {
					color: #613f25;

					.rmb {
						color: #613f25;
					}
				}

				// .desc {
				//   color: #d8bea4;
				//   background: linear-gradient(308deg, #342b2e 0%, #433e3e 100%);
				// }
			}

			// &:last-child{
			//   margin-right: 0.3rem;
			// }
		}

		// 连续包月提示
		.autoPayTips {
			padding-top: 0.15rem;
			font-size: 0.24rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666;
			line-height: 0.38rem;
		}

		// 会员权益
		.vipRights {
			padding-top: 0.3rem;

			.rightsBox {
				width: 6.9rem;
				height: 5.68rem;
				margin-bottom: 0.22rem;
				display: flex;
				flex-wrap: wrap;
				background: #fcf9f5;
				border-radius: 0.1rem;
				box-sizing: border-box;
				padding: 0.48rem 0 0.3rem 0;

				.rightsItem {
					height: 1.38rem;
					margin-bottom: 0.38rem;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;

					flex-shrink: 0;
					width: calc(100% / 3);

					.itemIcon {
						width: 0.9rem;
						height: 0.9rem;
						margin-bottom: 0.14rem;

						img {
							display: block;
							width: 0.9rem;
							height: 0.9rem;
						}
					}

					.itemName {
						font-size: 0.24rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #613f25;
					}
				}
			}
		}

		// 专享赛事
		.match {
			width: 100%;
			height: 1rem;
			margin-bottom: 0.4rem;
			background: #fcf9f5;
			border-radius: 0.1rem;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 0.3rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #613f25;
		}

		// 自动续费说明（IOS）
		.renewDesc {
			.renewTitle {
				font-size: 0.26rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #666666;
			}

			.descInfo {
				margin: 0.2rem 0 0.1rem 0;
				font-size: 0.24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 0.46rem;
			}
		}

		// 其他服务
		.serves {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-bottom: 0.2rem;
			margin-top: 0.3rem;

			.serveItem {
				flex-shrink: 0;
				width: 3.35rem;
				height: 0.6rem;
				margin-bottom: 0.2rem;
				display: flex;
				justify-content: center;
				align-items: center;
				background: #f7f7f7;
				border-radius: 0.06rem;

				font-size: 0.24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
			}
		}

		// 苹果无关
		.rights {
			text-align: center;
			margin-bottom: 0.3rem;
			font-size: 0.24rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 0.4rem;
		}

		// 底部固定
		.payInfo {
			width: 100%;
			height: 1.3rem;
			position: fixed;
			bottom: 0;
			left: 0;
			background: #ffffff;
			box-shadow: 0 -0.04rem 0.04rem 0 rgba(154, 154, 154, 0.1);
			padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
			padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2

			// z-index:2;
			.payBox {
				width: 100%;
				height: 100%;
				box-sizing: border-box;
				padding: 0.2rem 0.2rem 0.1rem 0.3rem;
				display: flex;
				justify-content: space-between;

				.total {
					.priceInfo {
						display: flex;
						align-items: baseline;

						.word {
							font-size: 0.28rem;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						.price {
							font-size: 0.6rem;
							font-family: BebasNeue;
							color: #a57359;

							.rmb {
								font-size: 0.3rem;
								font-family: PingFangSC-Medium, PingFang SC;
								font-weight: 500;
								color: #a57359;
							}
						}
					}

					.agreement {
						display: flex;
						font-size: 0.24rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;

						.agree1 {}

						.agree2 {
							color: #6e4713;
						}
					}
				}

				.payBtn {
					width: 3.4rem;
					height: 0.9rem;
					background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
					border-radius: 0.45rem;
					display: flex;
					justify-content: center;
					align-items: center;

					font-size: 0.32rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #613f25;
				}
			}
		}
	}

	.agreement {
			display: flex;
			align-items: center;
			justify-content: start;
			padding-left: .3rem;
			box-sizing: border-box;
			height: .88rem;
			width: 100%;
			background:#f7f7f7;
			position: absolute;
			top: -0.88rem;
			left: 0;
			.img-box {
				display: flex;
			}
			.icon_select_no {
				width:.35rem;
				height:.35rem;
				vertical-align: middle;
			}

			.checked {
				width:.35rem;
				height:.35rem;
				vertical-align: middle;
			}

			.agreement_text {
				display: flex;
				align-items: center;
				font-size: .26rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #000;
				margin-left: .16rem;
				span {
					color: #613f25;
				}
			}
		}
</style>
